/* eslint-disable */


/**
 * Create styles for `<Disclaimer />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<Disclaimer />` styles
 */
const disclaimerStyles = ({ theme }) => ({
  icon: {
    fontSize: 20,
    marginRight: theme.spacing(1),
  },
  nakedIcon: {
    marginRight: 12,
    opacity: 0.3,
  },
  warningIcon: {
    fontSize: 20,
    marginRight: 0,
  },
});

export default disclaimerStyles;
